import { Component ,  OnInit , Input , AfterViewInit , ViewChild , ElementRef , forwardRef, EventEmitter, Output, HostListener} 	from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { CommonAdminService } from '@tanzeel/shared';
import { validateCustomRequired } from '@tanzeel/shared';
import { StudentBlockUIService } from '@student/core/blockui/student-blockui.service';
import { StudentMessagingService } from '@student/core/messaging/student-messaging.service';
@Component({
        standalone: false,
  selector: 'student-promotion-popup',
  templateUrl: "./student.promotion.popup.html",
  styles : [
	`
		.donationdrive-modal-parent {
			position: absolute;
			left: 50%;
			z-index: 100;
			min-width : 50%;
			max-width : 90%;
		}
		.ui_modal.donationdrive-modal {
			position: relative;
			z-index: 101;
			max-width: 90%;
			left: -50%;
		}
		@media (max-width:767px) {
			.ui_modal.donationdrive-modal {
				max-width: 94%;
				margin-left: 3%;
			}
			.donationdrive-modal-parent {
				min-width : 85%;
			}
			.donationdrive-modal-parent .ui_modal .ui_modal_btns .ui_btn.ui_btn_primary {
				margin-top : 10px;
			}
		}
	`

  ]
})
export class UiKitPromotionModalComp implements OnInit , AfterViewInit  {

			
	@Output() close:any = new EventEmitter<any>();
	@Input() forStudent:any = 0;
	

	initialized:boolean = false;


	showError:boolean = false;

	studentObject:any = null;
	studentinfoForm:any = null;
	studentAddlInfo:any = null;
    constructor(private _el: ElementRef , private _cas:CommonAdminService , private mms:StudentMessagingService , private bks:StudentBlockUIService, private fb:FormBuilder ){
    }

    ngOnInit(){
		this.initialized=true;
		//console.info( " ************************************************** ");
		this.studentObject = this._cas.getLoggedInStudent( this.forStudent );
		this.studentinfoForm = this.fb.group({
			emails 			 		: [ '' , validateCustomRequired ]
		});
    }
		
	ngAfterViewInit() {

	}
	


	closeIcon(){
		this.close.emit();
	}

	emailsFldInFocus:boolean = false;

	emailsFldInFocussed():boolean {
		return ( this.studentinfoForm != null && (this.studentinfoForm.get('emails').value != null && this.studentinfoForm.get('emails').value != '' ) );
	}


	submit(  ){
		var val = this.studentinfoForm.value;
		this.bks.show();
		var ref = {
			emailAddress : val.emails 
		}
		this._cas.sendPromotionEmails( ref , this , this.sendPromotionEmailsSuccess ,this.sendPromotionEmailsFailure );
	}

	sendPromotionEmailsSuccess( data:any ){
		this.mms.info("success");
		this.bks.hide();
		this.closeIcon();
	}

	sendPromotionEmailsFailure( data:any ){
		try {
			this.mms.error( data.json().details );
		} catch (error) {
			this.mms.error(" failed ");	
		}
		
		this.bks.hide();
	}

	getStudentFullName(){
		if( this.studentObject != null)
			return this.studentObject.firstName;
		else 
			return "Null";
	}

	auto_grow( event:any ){
		
		var ele = event.target;
		ele.style.height = "5px";
		ele.style.height = (ele.scrollHeight)+"px";
	}
}